import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { useGlobal } from "../../hooks/global";
import { businessProps } from "../../interfaces";
import { CompanyDataForm } from "./CompanyDataForm";
import { DashboardPage } from "../../components/DashboardPage";
import { ContentOrLoading } from "../../components/Loadings/ContentOrLoading";
import { businessDefaultForm, mapDefaultForm } from "../../utils/defaultFormsUtils";
import { randomId } from "@mantine/hooks";
import { managedAccommodationsOptions } from "../../utils/options";

export const CompanyData: React.FC = () => {
    const { api, user } = useApi()
    const { notify, theme } = useGlobal()

    const [loading, setLoading] = useState(false)
    const [defaultData, setDefaultData] = useState<any>(null)
    const [default_franchise, setDefaultFranchise] = useState<businessProps | null>(null)

    const search = useCallback(async () => {
        setLoading(true)

        try {
            const { data } = await api.get(`/business/${user.bus_id}`)

            let _data: any = mapDefaultForm({ data, fields: businessDefaultForm })

            _data = {
                id: randomId(),
                ..._data,
                managed_accommodations: {
                    label: managedAccommodationsOptions.find((option) => option.value === _data?.managed_accommodations)?.label,
                    value: _data?.managed_accommodations,
                },
                state_id: { label: data?.state?.name, value: data?.state?.id },
                city_id: { label: data?.cities?.name, value: data?.cities?.id }
            };
            
            setDefaultData({ ..._data })

            setDefaultFranchise({ ...data })
        } catch (err) {

            notify("Erro ao Buscar Dados da Empresa!", "error")

        }

        setLoading(false)
    }, [api])

    useEffect(() => { search() }, [])

    return (
        <DashboardPage>
            <ContentOrLoading
                theme={theme}
                loading={loading}
                text={"Buscando Dados da Empresa"}
                children={(
                    <CompanyDataForm
                        defaultData={defaultData}
                        defaultFranchise={default_franchise}
                    />
                )}
            />
        </DashboardPage>
    )
}